export const importCardFreezeContainer = () =>
    import('@perpay-web/fintech/components/containers/CardFreezeContainer');
